import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Logo from "@/components/site/Logo";
import { useAdmin } from "@/context/AdminContext";
import { useI18n } from "@/context/I18nContext";

export default function AdminLogin() {
    const { t } = useI18n();
    const { token, login } = useAdmin();
    const navigate = useNavigate();
    const [email, setEmail] = useState("admin@jwdeli.com");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    if (token) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success("Welcome");
            navigate("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen grid place-items-center bg-muted px-4">
            <form
                onSubmit={submit}
                data-testid="admin-login-form"
                className="w-full max-w-sm bg-white rounded-3xl border border-border p-8 space-y-5"
            >
                <Link to="/" className="flex items-center gap-3 mb-2">
                    <Logo size={48} className="rounded-full bg-white shadow-sm" />
                    <span className="font-display font-black text-xl">J & W Deli</span>
                </Link>
                <div>
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary">
                        {t("admin.login")}
                    </p>
                    <h1 className="font-display font-black text-3xl mt-2">Welcome back</h1>
                </div>
                <Input
                    type="email"
                    placeholder={t("admin.email")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="admin-email"
                    required
                />
                <Input
                    type="password"
                    placeholder={t("admin.password")}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="admin-password"
                    required
                />
                <Button
                    type="submit"
                    disabled={busy}
                    data-testid="admin-signin"
                    className="w-full py-6 rounded-full bg-primary hover:bg-primary/90 font-bold uppercase tracking-widest"
                >
                    {busy ? "..." : t("admin.sign_in")}
                </Button>
            </form>
        </div>
    );
}
